(ns ycweb.app.website.auth.forgotpassword
  (:require
   [rum.core :as rum]
   [ycweb.app.website.auth.common :as auth.cmn]
   [ycweb.app.website.website :as website]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.hash :as hash]
   [ycweb.util.urlstate :as urlstate]))

(def password-atom (atom {:forgot-password {}}))

(defn validate-reset-password [{:user/keys [password password-confirmation]}]
  (let [errors (auth.cmn/validate-plain-text-password password password-confirmation {})]
    (cond
      (empty? (remove nil? (mapcat second errors)))
      {:success true}

      :else
      {:success false :errors errors})))

(defmethod grid/action :web.auth/reset-password [app-atom config _]
  (let [form-atom (rum/cursor password-atom :forgot-password)
        confirmed-passwords @form-atom
        reset-data (auth.cmn/yc-input-get-form-values form-atom)
        validation (validate-reset-password reset-data)]

    (cond
      (not (:success validation))
      (auth.cmn/display-input-errors password-atom (:errors validation) :forgot-password)

      :else
      (comms/ajax-post
        :web.auth/reset-password
        {:user/pwd
         (hash/md5
           (:value
            (:user/password confirmed-passwords)))
         :user/u (:u config)
         :user/p (:p config)}))))

(defmethod comms/receive :web.auth/reset-password [app-atom response]
  (let [{:keys [afterloginredirect]} (cmn/screen-params app-atom)]
    (cond
      afterloginredirect
      (urlstate/redirect app-atom "login" nil {:afterloginredirect afterloginredirect})

      :else
      (urlstate/redirect app-atom "login"))))

;; ========== RESET PASSWORD - INVALID ==========
(rum/defc auth-reset-invalid-body < rum/reactive cmn/cursors [app-atom _ _]
  [:<>
   [:div.modal__header
    (headings/heading "Link expired" {:type :h2 :size :default :flush true :class "modal__heading"})]
   [:div.modal__content
    [:p.yc-paragraph (str "The password creation link has expired.")]]
   (toaster/loading-overlay app-atom :web.login/user-login)])

(rum/defc auth-reset-invalid-footer < rum/reactive cmn/cursors [app-atom _ _]
  [:div
   (grid/button-row
     {:left-text "Try again"
      :left-fn #(urlstate/redirect app-atom "login" "forgotpassword")
      :right-text "Back to Login"
      :right-fn #(urlstate/redirect app-atom "login")})])

(defmethod grid/modal-config :web.login/invalid-check [_ _ _]
  {:body-raw auth-reset-invalid-body
   :footer auth-reset-invalid-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

;; ========== RESET PASSWORD - VALID ==========
(rum/defc auth-reset-valid-body < rum/reactive cmn/cursors [app-atom _ _]
  [:<>
   [:div.modal__header
    (headings/heading "Reset your password" {:type :h2 :size :default :flush true :class "modal__heading"})]
   [:div.modal__content
    [:p.yc-paragraph (str "Create a new password for your account")]
    (forms/password-input "New password:" "Enter your new password"
      (rum/cursor-in password-atom [:forgot-password :user/password])
      {:required? true
       :yc-input? true})
    (forms/password-input "Confirm new password:" "Confirm new password"
      (rum/cursor-in password-atom [:forgot-password :user/password-confirmation])
      {:required? true
       :yc-input? true})]
   (toaster/loading-overlay app-atom :web.login/user-login)])

(rum/defc auth-reset-valid-footer < rum/reactive cmn/cursors [app-atom _ _]
  (let [params (cmn/screen-params app-atom)]
    [:div
     (grid/button-row
       {:left-text "Back"
        :left-fn #(urlstate/redirect app-atom "login")
        :right-text "Submit"
        :right-fn
        #(grid/dispatch-action app-atom :web.auth/reset-password
           {:u (:u params) :p (:p params)})})]))

(defmethod grid/modal-config :web.login/valid-check [_ _ _]
  {:body-raw auth-reset-valid-body
   :footer auth-reset-valid-footer
   :modal-type :variable
   :cancel-key :auth-modal-close})

(defmethod flow/render-screen :web.login/cp [app-atom _]
  (website/screen-wrapper app-atom
    (auth.cmn/auth-landing-page app-atom "cp")
    {}))

(defmethod t/transition-open :web.login/cp [app-atom _ params]
  (comms/ajax-post :web.auth/check params))

(defmethod comms/receive :web.auth/check [app-atom e]
  (cond
    (:status e)
    (grid/open-modal app-atom
      :web.login/valid-check
      {:config
       {:size :small
        :blur-bg? true}})

    :else
    (grid/open-modal app-atom
      :web.login/invalid-check
      {:config
       {:size :small
        :blur-bg? true}})))